<template>
  <ion-toolbar>
    <ion-title>
      <!-- <span>Preferred Locum</span> -->
    </ion-title>
  </ion-toolbar>


  <div class="main_wrapper ion-padding">

    <div class="container container-fill-height">
      <div class="auth-header">
          <div class="auth-heading">
              <h1>Preferred Locum Invitation</h1>
          </div>
          
      </div>
      <div class="job_info_wrapper job_info_wrapper--custom">
      
  
  
        <div class="job_shifts_wrapper fullp">
  
          <div>
            <p>Hi,</p>
            <p>You have been invited to become a prefered locum for pharmacy <b>{{ pharmacyName }}</b>. Please accept the
              invitation, to be a preferred locum</p>
          </div>
          <div class="button_submit mb0">
            <div class="btns-group">
              <el-button class="submit_page w-full secondary" type="red" @click="gotToReject()">
                Decline
              </el-button>
              <el-button class="submit_page w-full" type="blue" @click="gotToAccept()">
                Accept
              </el-button>
            </div>
  
          </div>
        </div>
  
      </div>
    </div>
  </div>



</template>

<script>


import {
  ref,
  onMounted,
  inject,
  // computed,
} from "vue";
import { ElMessageBox } from "@/components/Vendor/Element";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
//  import formHooks from "@/hooks/form/form";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});

import { useStore } from "vuex";
import {
  useRouter,
  useRoute
} from "vue-router";
export default {
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const route = useRoute();

    const setPageClassGlobal = inject("setPageClassGlobal");

    let pharmacyName = ref('');
    const close = () => {
      $router.push({
        name: "auth",
      });
    }


    const gotToReject = () => {
      (async () => {
        try {
          await $store.dispatch("PREFERRED_LOCUM_REJECT", { invitationId: route.params.invitationId, });
          let massageText = {
            title: 'Preferred Locum Declined!',
            main: 'You have declined'
          };

          await ElMessageBox.confirm(massageText.main, massageText.title, {
            showCancelButton: false,
            confirmButtonText: 'Sign up to Locumate',
            confirmButtonClass: 'el-button--grey',
            showClose: true,
            type: 'warning',
            customClass: 'modal_success star declined-invitation',
            callback: () => {
              $router.push({
                name: "auth",
              });
            }
          });

        } catch (error) {
          console.log(error);
          console.log("error submit!!");
        }
      })();
    }

    const gotToAccept = () => {


      (async () => {
        try {
          await $store.dispatch("PREFERRED_LOCUM_ACCEPT", { invitationId: route.params.invitationId, });
          localStorage.setItem('preferred_locum_invitation_id', route.params.invitationId);
          let massageText = {
            title: 'Preferred Locum Accepted!',
            main: 'You have accepted'
          };

          await ElMessageBox.confirm(massageText.main, massageText.title, {
            showCancelButton: false,
            confirmButtonText: 'Ok',
            confirmButtonClass: 'el-button--grey',
            showClose: false,
            type: 'success',
            customClass: 'modal_success star',
            callback: () => {
              $router.push({
                name: "home",
              });
            }
          });

        } catch (error) {
          console.log(error);
          console.log("error submit!!");
        }
      })();
    }


    onMounted(() => {
      setPageClassGlobal("global_job_book_page");
      (async () => {
        const preferredInfo = await $store.dispatch("GET_PREFERRED_LOCUM_INFO", {
          invitationId: route.params.invitationId,
        });
        pharmacyName.value = preferredInfo.pharmacyName;
      })();
      //    console.log('sadhajkdhsjkahdjksahdjksad');
      //    console.log("from page hai", route.params.invitationId );
    });


    return {

      gotToAccept,
      gotToReject,
      pharmacyName,

      close
    };
  },
};
</script>